/**
 * Entrée i18n de l'app date-polls.
 * Importe la config partagée (core) puis enregistre les namespaces produits `polls` et `settings`
 * propres à cette app — les autres apps ne bundlent donc pas ces strings.
 */
import i18n, { registerNamespace } from "@core/i18n";

import frPolls from "@core/i18n/locales/fr/polls.json";
import enPolls from "@core/i18n/locales/en/polls.json";
import esPolls from "@core/i18n/locales/es/polls.json";

import frSettings from "./locales/fr/settings.json";
import enSettings from "./locales/en/settings.json";
import esSettings from "./locales/es/settings.json";

import frPwaInstall from "./locales/fr/pwaInstall.json";
import enPwaInstall from "./locales/en/pwaInstall.json";
import esPwaInstall from "./locales/es/pwaInstall.json";

// Réutilise common.json de @core pour les clés partagées (enabled, disabled, saving, saved)
import frCommon from "@core/i18n/locales/fr/common.json";
import enCommon from "@core/i18n/locales/en/common.json";
import esCommon from "@core/i18n/locales/es/common.json";

registerNamespace("polls", { fr: frPolls, en: enPolls, es: esPolls });
registerNamespace("settings", {
  fr: frSettings,
  en: enSettings,
  es: esSettings,
});
registerNamespace("pwaInstall", {
  fr: frPwaInstall,
  en: enPwaInstall,
  es: esPwaInstall,
});
registerNamespace("common", {
  fr: frCommon,
  en: enCommon,
  es: esCommon,
});

export default i18n;
